import { SuperAdminService } from "services/superAdminService";

class RoomTypesSAService extends SuperAdminService<any> {
  constructor() {
    super("room-types");
  }
}
export default new RoomTypesSAService();
